import React, { useEffect } from 'react';
import '../../IntegrationBaseComponent.scss';
import { FacebookAdsIntegrationsHeader } from './FacebookAdsIntegrationsHeader';
import {
  Grid,
  GridLabels,
  GridRow,
} from '../../../../../../../../common/components/Grid/Grid';
import {
  ComponentDataItem,
  DefaultCell,
} from '../../../../../../contacts/components/ContactsTable/ContactTable';
import { TableLabel } from '../../../../../../../../common/components/TableGrid/TableGrid';
import { landmineNames } from '@mm/constants/landmine-names';
import { BaseIntegration } from '../../../BaseIntegration/BaseIntegration';
import { BaseIntegrationHeader } from '../../../BaseIntegration/BaseIntegrationHeader';
import { FacebookSquaredIcon } from '@mm/icons';
import { FormattedConnectionModel } from '@mm/state/model/ConnectionModel';
import { useAdAccount } from './use-ad-account';
import { useSelector } from 'react-redux';
import { selectActiveAdAccount } from '@mm/state/selectors/adAccountsSelecotrs';
import { selectAdAudiences } from '@mm/state/selectors/adAudiencesSelector';

type Props = {
  cellData: ComponentDataItem[];
  name?: string;
};

export const FacebookAdsTable = (props: Props) => {
  const { cellData, name } = props;
  const activeAdAccount = useSelector(selectActiveAdAccount);
  const entities = useSelector(selectAdAudiences);

  const gridTemplateColumns = `25% 25% 35% 15%`;

  const headerComponent = (
    <FacebookAdsIntegrationsHeader count={entities.length} name={name} />
  );

  const sectionProps = {
    landmineName: landmineNames?.INTEGRATIONS_FACEBOOK_ADS,
  };

  return (
    <BaseIntegration
      titleComponent={
        <BaseIntegrationHeader
          title="Facebook"
          subtitle={
            activeAdAccount ? `${activeAdAccount?.name} is connected` : ''
          }
          icon={<FacebookSquaredIcon />}
          headerRightComponent={headerComponent}
          css={{ icon: 'integrations__header-icon-facebook' }}
          {...sectionProps}
        />
      }
      emptyStateConfig={{
        button: <span>No Synced Audiences</span>,
        onClick: () => {},
        icon: <FacebookSquaredIcon />,
        ...sectionProps,
      }}
      showEmptyState={!entities.length}
    >
      <Grid className="integrations-grid">
        <>
          <GridLabels
            className="integrations-grid__labels"
            gridTemplateColumns={gridTemplateColumns}
          >
            {cellData.map(cell => (
              <TableLabel
                key={(cell.keyName as string) || cell.label}
                dataItem={cell}
                orderByAtTheEnd
              />
            ))}
          </GridLabels>

          <div className="integrations-grid__rows-container">
            {entities.map(item => (
              <GridRow key={item.id} gridTemplateColumns={gridTemplateColumns}>
                {cellData.map(({ Cell, keyName }) => {
                  return Cell ? (
                    <Cell key={keyName} item={item} />
                  ) : (
                    <DefaultCell keyName={keyName as string} item={item} />
                  );
                })}
              </GridRow>
            ))}
          </div>
        </>
      </Grid>
    </BaseIntegration>
  );
};
